import { NavLink, useLocation } from 'react-router-dom';
import styles from './MPs.module.scss';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { formatDate } from '../../../../functions/formatDate';

const MPs = () => {
  const location = useLocation();
  const MPsRedux = useSelector((state) => state.MPs.MPs);

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.cards}>
        {MPsRedux.map((MP) => {
          return (
            <NavLink to={`/masterplan/${MP.id}`} key={MP.id} className={styles.card}>
              <div className={styles.image}>
                <img src={`https://ingorod24.ru/${MP.preview}`} alt="preview" />
              </div>
              <h2 className={styles.title}>Мастер-план</h2>
              <p className={styles.description}>{MP.title}</p>
              {/* <p className={styles.description}>{MP.short_description}</p> */}
              <p className={styles.dates}>
                {MP?.stages_period?.first_start ? formatDate(MP.stages_period.first_start) : '—'}
                {' - '}
                {MP?.stages_period?.last_end ? formatDate(MP.stages_period.last_end) : '—'}
              </p>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default MPs;
